//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from "vue";
import {
  ShoppingContext,
  PersonalOfferStorageService,
  SponsorStorageService,
  events,
  StoreFrontSponsorStorageService
} from "@nuskin/ns-util";
import { MySiteRestService } from "@nuskin/my-site-api";
import {
  CartService,
  CurrencyService,
  PersonalOfferService,
  EquinoxCartService,
  Product as ShopProduct
} from "@nuskin/ns-shop";
import { getCachedConfiguration } from "@nuskin/configuration-sdk";
import { AccountService } from "@nuskin/ns-account";
import { isNullOrEmpty, isNumber } from "@nuskin/ns-common-lib";
// eslint-disable-next-line no-unused-vars
import { NsSpinner, NsIcon } from "@nuskin/design-components";
import { waitForConfig } from "../services/configHelper";
import debounce from "lodash/debounce";

import NsCurrency from "./NsCurrency.vue";
import NsProductCard from "./NsProductCard.vue";

export default {
  name: "NsProductOffer",
  components: {
    NsSpinner,
    // eslint-disable-next-line vue/no-unused-components
    NsCurrency,
    NsProductCard
  },
  props: {
    // the store owner/user id
    storeId: {
      type: String,
      default: ""
    },

    // the personal/product offer - otherwise known as pitch - id
    offerId: {
      type: String,
      default: ""
    },

    // required translations used in the component
    translations: {
      type: Object,
      required: true
    },

    /**
     * The privacy overlay message. shows if both privacy fields are authored for given product over
     */
    privacyOverlayMessage: {
      type: String,
      default: ""
    },

    /**
     * The privacy overlay button text. shows if both privacy fields are authored for given product offer
     */
    privacyOverlayButtonText: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      market: "",
      language: "",
      currencyCode: "",
      queryStoreId: "",
      queryOfferId: "",
      storeOwner: null,
      storePreferredName: "",
      offer: null,
      discount: null,
      isAdr: false,

      products: {},
      totalProducts: 0,
      totalProductQuantity: 0,
      localTranslations: {},
      localPrivacyOverlayMessage: "",
      localPrivacyOverlayButtonText: "",

      offerLoading: true,
      offerNotFound: false,
      offerExpired: false,
      hideDiscount: true,
      someProductsValid: false,

      offerSavings: 0,
      showOfferSavings: false,
      offerSavingsBeforeHtml: "",
      offerSavingsAfterHtml: "",

      originalOfferTotal: 0,
      offerTotal: 0,
      showOfferTotal: false,
      offerTotalBeforeHtml: "",
      offerTotalAfterHtml: ""
    };
  },
  computed: {
    runConfig() {
      return this.$NsProductAppService.runConfig;
    },
    showWholeSalePricing() {
      return this.$NsProductAppService.showWholeSalePricing;
    },
    isLoggedIn() {
      return this.$NsProductUserService.isLoggedIn;
    },
    user() {
      return this.$NsProductUserService.user;
    },
    userId() {
      return this.$NsProductUserService.userId;
    },
    isDistributor() {
      return this.$NsProductUserService.isDistributor;
    },
    isPreferredCustomer() {
      return this.$NsProductUserService.isPreferredCustomer;
    },
    localStoreId() {
      return this.storeId || this.queryStoreId || (this.storeOwner || {}).sapId;
    },
    isStorefront() {
      return !!this.localStoreId;
    },
    localOfferId() {
      return (this.offer || {}).pitchID || this.offerId || this.queryOfferId;
    },
    isPersonalOffer() {
      return (
        !!this.localOfferId &&
        ((this.offer || {}).active === undefined || !!(this.offer || {}).active)
      );
    },
    disableAddAll() {
      return this.offerLoading || this.totalProductQuantity === 0;
    },
    productsLoading() {
      return this.$NsProductDataService.batches.some(
        batch =>
          !["success", "failed"].includes(batch.status) &&
          batch.skus.some(batchSku =>
            Object.keys(this.products).includes(batchSku)
          )
      );
    },
    showOffer() {
      return (
        !this.offerLoading &&
        !this.productsLoading &&
        !this.offerNotFound &&
        !this.offerExpired &&
        this.someProductsValid
      );
    },
    mobileOrPhablet() {
      return this.$mq === "phablet" || this.$mq === "mobile";
    },
    hideBottomPurchaseAll() {
      return (
        (!this.mobileOrPhablet && this.totalProducts < 7) ||
        (this.mobileOrPhablet && this.totalProducts < 3)
      );
    },
    approvedMessage() {
      // verify approvedMessage is passed from AEM
      if (
        this.localTranslations &&
        this.localTranslations.approvedMessage &&
        this.localTranslations.approvedMessage.length > 0
      ) {
        // verify linkText and linkUrl are passed from AEM
        const isApprovedMessageLinkText =
          this.localTranslations.approvedMessageLinkText &&
          this.localTranslations.approvedMessageLinkText.length > 0;
        const isApprovedMessageLinkUrl =
          this.localTranslations.approvedMessageLinkUrl &&
          this.localTranslations.approvedMessageLinkUrl.length > 0;
        const approvedMessageAnchorElement =
          isApprovedMessageLinkText && isApprovedMessageLinkUrl
            ? `<a href='${this.localTranslations.approvedMessageLinkUrl}' target='_blank'>${this.localTranslations.approvedMessageLinkText}</a>`
            : null;
        let approvedMessageWithoutLink = `${this.localTranslations.approvedMessage}`;
        if (!isApprovedMessageLinkText || !isApprovedMessageLinkUrl) {
          return approvedMessageWithoutLink;
        }
        const approvedMessageWithLink = approvedMessageWithoutLink.replace(
          "{linkText}",
          approvedMessageAnchorElement
        );
        return approvedMessageWithLink;
      }
      return null;
    }
  },
  watch: {
    async translations() {
      await this.checkToInit();
    },
    productsLoading(productsLoading) {
      if (!productsLoading) {
        this.checkProductsHaveData();
      }
    }
  },
  async mounted() {
    await this.addListeners();
  },
  beforeDestroy() {
    this.removeListeners();
  },
  methods: {
    async checkToInit() {
      // in AEM, the storeId (userId) and offerId (pitchId) are query parameters
      const searchParams = new URLSearchParams(window.location.search);
      const queryStoreId =
        searchParams.get("storeId") || searchParams.get("userId") || "";
      const queryOfferId =
        searchParams.get("offerId") || searchParams.get("pitchId") || "";

      const storeId = this.storeId || queryStoreId;
      const offerId = this.offerId || queryOfferId;

      //  app service needs to be loaded, market and language need to be different, and translations are required
      if (
        !this.$NsProductAppService.loading &&
        (!this.market ||
          this.market !== this.runConfig.country ||
          !this.language ||
          this.language !== this.runConfig.language ||
          (!!storeId && storeId !== this.localStoreId) ||
          (!!offerId && offerId !== this.localOfferId)) &&
        !isNullOrEmpty(this.translations)
      ) {
        this.market = this.runConfig.country;
        this.language = this.runConfig.language;

        this.currencyCode = CurrencyService.getCurrency(
          this.market
        ).currencyCode;

        this.localTranslations = { ...(this.translations || {}) };
        this.localPrivacyOverlayButtonText =
          this.privacyOverlayButtonText || "";
        this.localPrivacyOverlayMessage = this.privacyOverlayMessage || "";

        this.queryStoreId = queryStoreId;
        this.queryOfferId = queryOfferId;

        await waitForConfig();
        await this.init();
      }
    },

    async init() {
      this.storeOwner = StoreFrontSponsorStorageService.getStoreFrontSponsor();

      const shoppingContext = ShoppingContext.getShoppingContext();
      if (
        (!isNullOrEmpty(this.storeOwner) ||
          (!!this.localStoreId && !!this.localOfferId)) &&
        (isNullOrEmpty(shoppingContext) ||
          !ShoppingContext.isContext(ShoppingContext.PERSONAL_OFFER))
      ) {
        ShoppingContext.setShoppingContext(ShoppingContext.PERSONAL_OFFER);
      }

      if (
        !!this.localStoreId &&
        (isNullOrEmpty(this.storeOwner) ||
          this.storeOwner.sapId !== this.localStoreId)
      ) {
        let sponsor = null;

        try {
          // getSponsorData threw an error for accessing user id when the user/sponsor isn't found, catch it
          sponsor = await MySiteRestService.getSponsorData(this.localStoreId);
        } catch (err) {
          console.error("Unable to get Store Owner. Error: ", err);
        }

        if (!isNullOrEmpty(sponsor)) {
          StoreFrontSponsorStorageService.setStoreFrontSponsor(sponsor);
          this.storeOwner = sponsor;
        } else {
          StoreFrontSponsorStorageService.clearStoreFrontSponsor();
          this.storeOwner = {};
        }
      }

      if (this.localOfferId) {
        // get store preferred name from account service if possible
        const storeOwnerAccountInfo = await AccountService.getAccountInfo(
          this.localStoreId
        );
        this.storePreferredName =
          (this.storeOwner || {}).displayName ||
          (storeOwnerAccountInfo || {}).preferredName;

        this.setT(
          "offerNotFound",
          this.t("offerNotFound").replace("{user}", this.storePreferredName)
        );

        this.setT(
          "offerExpired",
          this.t("offerExpired").replace("{user}", this.storePreferredName)
        );

        await this.getOffer();

        // without these, required to refresh for runConfig/context changes
        this.$NsProductAppService.setConfig(this.runConfig);

        const appService = Vue.prototype.$NsAppService;
        if (!isNullOrEmpty(appService)) {
          appService.setConfig(this.runConfig);
        }

        this.offerLoading = false;
      } else {
        this.offerNotFound = true;
        this.showOfferSavings = false;
        this.offerLoading = false;
      }
    },

    async getOffer() {
      const offer = await PersonalOfferService.getOfferV2(
        this.localStoreId,
        this.localOfferId
      );

      if (isNullOrEmpty(offer)) {
        this.offerNotFound = true;
        return;
      }

      await this.getOfferPitch(offer);

      if (this.offerNotFound || this.offerExpired) {
        return;
      }

      this.isAdr = !!offer.useADR;

      const storageOffer = localStorage.getItem("personalOffer_v2");
      const parsedOffer = !isNullOrEmpty(storageOffer)
        ? JSON.parse(storageOffer)
        : null;
      const currentSessionId = (parsedOffer || {}).sessionId;
      const currentSession = currentSessionId
        ? (offer.sessions || {})[currentSessionId]
        : null;

      // new session
      if (!currentSession) {
        try {
          const viewedResponse = await PersonalOfferService.callViewed(
            this.localStoreId,
            this.localOfferId
          );
          PersonalOfferStorageService.setSessionId(viewedResponse.sessionId);
        } catch (err) {
          console.error("Unable to set offer as viewed. Error: ", err);
        }
      }
    },

    async getOfferPitch(offer) {
      if (
        (this.offerId && this.offerId !== offer.pitchID) ||
        (this.queryOfferId && this.queryOfferId !== offer.pitchID)
      ) {
        CartService.clearCart();
      }

      let response = await PersonalOfferService.getPitch(
        this.localStoreId,
        this.localOfferId
      );

      let responseObject =
        (response || {}).data && Object.keys(response.data).length
          ? response.data
          : null;

      if (
        isNullOrEmpty(responseObject) ||
        (!responseObject.items && !responseObject.products)
      ) {
        response = {
          data: offer
        };
      }

      responseObject =
        response && response.data && Object.keys(response.data).length
          ? response.data
          : null;

      //Check if offer has expiration date that is older than midnight the next day
      if (responseObject && responseObject.expirationDate) {
        let currentDate = new Date();
        currentDate.setHours(0);
        currentDate.setMinutes(0);
        currentDate.setSeconds(0);
        currentDate.setMilliseconds(0);
        // The expiration = 00:00 the next day (CX9-8164)
        let expirationDate = new Date(responseObject.expirationDate);
        expirationDate.setTime(
          expirationDate.getTime() + expirationDate.getTimezoneOffset() * 60000
        );
        expirationDate.setHours(0);
        expirationDate.setMinutes(0);
        expirationDate.setSeconds(0);
        expirationDate.setMilliseconds(0);
        if (expirationDate.getTime() < currentDate.getTime()) {
          this.offerExpired = true;
          return;
        }
      }

      if (
        !responseObject ||
        responseObject.active === false ||
        responseObject.isDeleted ||
        (!responseObject.items && !responseObject.products)
      ) {
        this.offerExpired = true;
        return;
      }
      responseObject.sapId = this.localStoreId;
      responseObject.pitchID = this.localOfferId;

      responseObject.congratulations =
        responseObject.congratulations || responseObject.confirmationMessage;
      responseObject.isGroupOffer =
        responseObject.isGroupOffer || responseObject.isGroup;
      responseObject.language =
        responseObject.language || responseObject.languageCode;
      responseObject.greeting =
        responseObject.greeting || responseObject.message;
      responseObject.items =
        responseObject.items ||
        responseObject.products.map(item => {
          return {
            SKU: item.sku,
            RequestedQuantity: item.qty
          };
        });

      const useMemberPricing = !!responseObject.useMemberPricing;
      ShoppingContext.setShoppingContext(ShoppingContext.PERSONAL_OFFER, {
        showWholeSalePricing: useMemberPricing,
        allowAnonymousShopping: !useMemberPricing,
        preferredSignupOnly: useMemberPricing
      });

      responseObject.landingPageURL = window.location.href;
      SponsorStorageService.setSponsor(responseObject.sapId);

      this.setT(
        "offerName",
        this.t("offerName").replace("{name}", responseObject.name)
      );

      responseObject.name =
        this.localTranslations.offerName != " "
          ? this.localTranslations.offerName
          : responseObject.name; //if offername returns empty space, taking name from response data
      this.offer = responseObject;

      if (this.isLoggedIn) {
        if (this.isDistributor || this.isPreferredCustomer) {
          this.discount = {
            code: "RETAILPRICE",
            description: "RetailPricing",
            multiplier: 1
          };
          responseObject.discount = this.discount;
        } else {
          this.discount = responseObject.discount;
        }
      } else {
        this.discount = responseObject.discount;
      }

      PersonalOfferStorageService.setPersonalOffer(responseObject);
      let multiplier = this.discount ? this.discount.multiplier : 1;
      this.hideDiscount = Number(multiplier) == 1;

      for (const item of responseObject.items) {
        this.products[item.SKU] = {
          sku: item.SKU,
          requestedQuantity: item.RequestedQuantity,
          data: {}
        };
      }
      this.totalProducts = Object.keys(this.products).length;

      events.publish(events.shop.PRODUCT_IMPRESSION, {
        ecommerce: {
          currencyCode: this.currencyCode,
          impressions: responseObject.items.map((item, index) => {
            return {
              id: item.SKU,
              name: item.name,
              price: item.price,
              quantity: item.RequestedQuantity,
              // "category": item.category, // category comes from EDW categories
              position: index,
              list: "pitchapp"
            };
          })
        }
      });
    },

    t(key) {
      return (this.translations || {})[key] || "";
    },

    setT(key, value) {
      this.$set(this.localTranslations, key, value);
    },

    modifyProduct(sku, props) {
      if (this.products[sku]) {
        this.products[sku] = { ...this.products[sku], ...props };
      } else {
        this.products[sku] = props;
      }

      this.checkProductsHaveData();
    },

    handleProductUpdate(product) {
      if ((product || {}).sku && this.products[product.sku]) {
        this.products[product.sku].data = product;
      }

      this.checkProductsHaveData(true);
    },

    checkProductsHaveData: debounce(function(dataAvailable) {
      const products = Object.values(this.products);
      if (products.every(product => !isNullOrEmpty(product.availability))) {
        this.someProductsValid = products.some(
          product =>
            !isNullOrEmpty(product.availability) && !isNullOrEmpty(product.data)
        );

        this.getOfferPrice();

        if (
          dataAvailable &&
          products.every(product => isNullOrEmpty(product.data))
        ) {
          this.offerNotFound = true;
        }
      }
    }, 250),

    async addFullOfferToCart() {
      const selectedQuantityArr = [];
      const validSkus = Object.keys(this.products)
        .map(sku => {
          if (Object.keys(this.products[sku].data).length) {
            const availableQuantity = Object.keys(
              this.products[sku].data.variants
            ).length
              ? this.products[sku].data.variants[this.products[sku].activeSku]
                  .availableQuantity
              : this.products[sku].availableQuantity || 0;
            const selectedQuantity = this.products[sku].availability
              .selectedQuantity;
            if (
              this.products[sku].invalid ||
              this.products[sku].data.availableQuantity <= 0 ||
              !this.products[sku].availability.addToCart
            ) {
              return undefined;
            }
            if (!this.products[sku].invalid && availableQuantity >= 1) {
              selectedQuantityArr[
                this.products[sku].activeSku
              ] = selectedQuantity;
              return this.products[sku].activeSku;
            } else {
              selectedQuantityArr[this.products[sku].sku] = selectedQuantity;
              return this.products[sku].sku;
            }
          }
        })
        .filter(sku => sku !== undefined);

      if (!validSkus.length) {
        return;
      }

      let options = {
        add: {
          item: {
            qty: this.totalProductQuantity
          }
        }
      };

      let checkoutProducts = [];
      const equinoxMarketsConfig = getCachedConfiguration("Equinox_Markets");
      const countryCode = equinoxMarketsConfig.country_code;

      if (equinoxMarketsConfig.active) {
        window.sessionStorage.setItem("nstoast-allowed", "true");
        EquinoxCartService.addBundleToEquinoxCart(
          validSkus,
          this.products,
          selectedQuantityArr
        )
          .then(() => {
            events.publish(events.shop.ADD_TO_CART, options);
          })
          .catch(err => {
            console.error(`Failed to add ${validSkus} with Error: ${err} `);
          });
      } else {
        for (const validSku of validSkus) {
          const validProduct = this.products[validSku];
          const selectedSku = validProduct.activeSku;
          const selectedQuantity = validProduct.availability.selectedQuantity;
          const cartOptions = {
            sku: selectedSku,
            product: validProduct.data,
            qty: selectedQuantity,
            userId: this.userId,
            cntryCd: countryCode,
            adr: false,
            referrer: "myStore",
            domain: window.location.hostname
          };

          cartOptions.product = new ShopProduct(cartOptions.product);
          try {
            await CartService.addProductToCart(cartOptions);

            events.publish(events.shop.ADD_TO_CART, cartOptions);

            events.publish(events.shop.ADD_TO_CART_NEW, {
              event: "addToCart",
              ecommerce: {
                currencyCode: this.currencyCode,
                add: {
                  actionField: {
                    list: "myStore"
                  },
                  products: [
                    {
                      name: validProduct.data.title,
                      id: selectedSku,
                      price: validProduct.availability.price,
                      quantity: selectedQuantity,
                      method: "personaloffer", // personal offer or quickView or productPage or cart
                      cartType: "Standard"
                    }
                  ]
                }
              }
            });

            // events.publish(events.shop.SHOW_ADD_TO_BAG, cartOptions);

            checkoutProducts.push({
              name: validProduct.data.title,
              id: selectedSku,
              price: validProduct.availability.price,
              quantity: selectedQuantity
            });
          } catch (error) {
            console.error(
              `Failed to add '${selectedSku}' x${selectedQuantity} to cart. Error: `,
              error
            );
          }
        }
      }

      if (!checkoutProducts.length) {
        return;
      }

      events.publish(events.shop.CART_CHECKOUT, {
        event: "checkout",
        ecommerce: {
          currencyCode: this.currencyCode,
          checkout: {
            actionField: { step: 2 },
            products: checkoutProducts
          }
        }
      });

      try {
        await PersonalOfferService.callProduct(
          this.localStoreId,
          this.localOfferId
        );
      } catch (err) {
        console.error("Failed updating product status to 'product_added'");
      }

      CartService.goToCartPage({ isMySite: true });
    },

    getOfferPrice() {
      let totalPrice = 0;
      this.totalProductQuantity = 0;

      for (const sku of Object.keys(this.products)) {
        this.products[sku].invalid = true;
        const availability = this.products[sku].availability;
        const availableQuantity =
          this.products[sku].data.availableQuantity || 0;

        if (
          availability &&
          (availability.addToCart || availability.addToAdr) &&
          Object.keys(this.products[sku].data).length >= 1 &&
          availableQuantity >= 1
        ) {
          const selectedQuantity = availability.selectedQuantity || 0;
          if (selectedQuantity > 0) {
            const price = availability.addToCart
              ? availability.price
              : availability.adrPrice || 0;

            totalPrice += price * selectedQuantity;
            this.totalProductQuantity += selectedQuantity;
            this.products[sku].invalid = false;
          }
        }
      }

      this.setT(
        "addAllItems",
        this.t("addAllItems").replace("{qty}", this.totalProductQuantity)
      );

      if (isNumber(totalPrice)) {
        this.originalOfferTotal = totalPrice;
        this.offerTotal = totalPrice;

        if (
          (this.discount && !this.user) ||
          (this.user &&
            (this.user.priceType === "RTL" ||
              this.user.priceType === "WRTL" ||
              this.user.isGuest))
        ) {
          let multiplier = this.discount ? this.discount.multiplier : 1;

          this.offerTotal = totalPrice * multiplier;
          this.offerSavings = this.originalOfferTotal - this.offerTotal;

          const discountNum = Math.round((1 - multiplier) * 100);
          this.showOfferSavings =
            this.offerSavings > 0 && parseInt(discountNum);
          if (this.showOfferSavings) {
            this.setT(
              "discountPercentagePrice",
              this.t("discountPercentagePrice").replace(
                "{percent}",
                discountNum
              )
            );
            const discountPercentagePrice = this.localTranslations
              .discountPercentagePrice;
            const offerSavingsHtmlParts = discountPercentagePrice.split(
              "{savings}"
            );
            this.offerSavingsBeforeHtml = offerSavingsHtmlParts[0];
            this.offerSavingsAfterHtml =
              offerSavingsHtmlParts.length > 1 ? offerSavingsHtmlParts[1] : "";
          }
        } else {
          this.hideDiscount = true;
          this.showOfferSavings = false;
        }

        const offerTotalHtmlParts = this.t("bundleTotal").split("{price}");
        this.showOfferTotal = offerTotalHtmlParts.length > 1;
        this.offerTotalBeforeHtml = offerTotalHtmlParts[0];
        this.offerTotalAfterHtml = this.showOfferTotal
          ? offerTotalHtmlParts[1]
          : "";

        this.offerNotFound = false;
      } else {
        this.offerNotFound = true;
      }
    },

    closeOverlay() {
      document.getElementById("pitchOverlay").style.width = "0%";
    },
    /**
     * Handle product status events
     */
    handleProductStatus(results) {
      this.$NsProductDataService.handleProductStatus(results);
    },

    /**
     * Handle product status events
     */
    handleVariantSelected(results, sku) {
      this.products[sku].activeSku = results;
      this.getOfferPrice();
    },

    /**
     * Subscribe to events, should only be called when mounted
     */
    async addListeners() {
      // watch app service finished loading
      this.$watch(
        "!$NsProductAppService.loading",
        async () => await this.checkToInit(),
        {
          immediate: true
        }
      );

      // listen to config changes
      this.$NsProductAppService.$on(
        "config-changed",
        async () => await this.checkToInit()
      );

      events.subscribe(events.authentication.REQUEST_FOR_LOGIN, function() {
        CartService.clearCart();
      });

      // listen to product status changes
      events.subscribe(
        events.shop.PRODUCT_STATUS_RESULT,
        this.handleProductStatus
      );
    },

    /**
     * Unsubscribe from events, should only be called when destroyed
     */
    removeListeners() {
      // stop listening to product app service events
      this.$NsProductAppService.$off();

      // stop listening to product status changes
      events.unsubscribe(
        events.shop.PRODUCT_STATUS_RESULT,
        this.handleProductStatus
      );
    }
  }
};
